<div class="modal-header">
    <h4 class="modal-title">Functionality Unavailable</h4>
</div>
<div class="modal-body">
    <p>Duplicating a Template is not available on portals where clients have not purchased the Comply module (i.e., Act 48 module only clients).  
        If you are interested in adding the Comply module to your portal, including the ability to duplicate Templates please contact us at
         <a target="_blank" href="https://edulinksolutions.com/contact/">https://edulinksolutions.com/contact/</a></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="activeModal.close()">Ok</button>
</div>